import { Controller, useFormContext } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import { th } from 'date-fns/locale';
import { CalendarRtlFilled } from '@fluentui/react-icons';
import { parse } from 'date-fns';

interface DatePickerInputProps {
  fieldKey: string;
  readonly?: boolean;
  byTimeZone?: boolean;
  error?: any;
  errorMessage?: string;
}

const DatePickerInput = (props: DatePickerInputProps) => {
  const { control } = useFormContext();

  const parseDate = (value: any) => {
    if (!value) return null;
    // Handle ISO format (2019-11-28T00:00:00.000Z)
    if (typeof value === 'string' && value.includes('T')) {
      return new Date(value);
    }
    // Handle DD-MM-YYYY format
    if (typeof value === 'string' && value.includes('-')) {
      return parse(value, 'dd-MM-yyyy', new Date());
    }
    // Handle Date object
    if (value instanceof Date) {
      return value;
    }
    return null;
  };

  return (
    <>
      <Controller
        name={props.fieldKey}
        control={control}
        rules={{
          validate: (value) =>
            !props.readonly && !value ? props?.errorMessage : true,
        }}
        render={({ field: { onChange, value } }) => {
          return (
            <div className="relative w-full z-99">
              <DatePicker
                selected={parseDate(value)}
                onChange={(date) => {
                  onChange(date || null);
                }}
                disabled={props.readonly}
                locale={th}
                dateFormat="dd MMMM yyyy"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                showTimeSelectOnly={false}
                className={`w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 text-black outline-none focus:border-primary focus-visible:shadow-none dark:border-form-strokedark ${
                  props.error && '!border-danger'
                } disabled:bg-grayalt8`}
                placeholderText="เลือกวันที่และเวลา"
                wrapperClassName="w-full"
                calendarClassName="bg-white border border-gray rounded-lg shadow-lg flex"
              />

              <CalendarRtlFilled className="absolute top-1/2 transform -translate-y-1/2 right-3 text-primary text-2xl pointer-events-none" />
            </div>
          );
        }}
      />
      {props.error && <p className="text-danger">{props.error.message}</p>}
    </>
  );
};

export default DatePickerInput;
